export function formatDriverCurrency(value,unit='paise') {
 if(typeof value!=='number'||!Number.isFinite(value)||Math.abs(value)>Number.MAX_SAFE_INTEGER||!['paise','rupees'].includes(unit)||(unit==='paise'&&!Number.isSafeInteger(value)))return 'Unavailable';
 return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR'}).format(unit==='paise'?value/100:value);
}
export function confirmedCashRemaining(order) {
 // Allocation fields are paise. Never substitute a customer fare or payment method.
 const fields=[order?.finalFare,order?.walletPaid,order?.onlinePaid,order?.cashDue];
 if(!fields.every(value=>Number.isSafeInteger(value)&&value>=0))return undefined;
 const paid=order.cashPaid??0;if(!Number.isSafeInteger(paid)||paid<0)return undefined;
 const sum=order.walletPaid+order.onlinePaid+order.cashDue+paid;
 return Number.isSafeInteger(sum)&&sum===order.finalFare?order.cashDue:undefined;
}
